import {AfterContentInit, Component, ContentChildren, Inject, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewContainerRef} from '@angular/core';
import {TabComponent} from '../tab/tab.component';
import {DataTabs} from '../../../models/tabs-data';
import {ActivatedRoute} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {Role} from '../../..';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})

export class TabsComponent implements OnInit, AfterContentInit, OnDestroy {

  @Input() data: DataTabs;
  // tslint:disable-next-line:no-any
  @Input() hideTabTile: any;
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
 // @ViewChild('componentContainer', { read: ViewContainerRef }) container;
  @ViewChild('componentContainer', {static: false , read: ViewContainerRef }) container;
  private sub$: Subscription;
  tabDisplay: TabComponent;
  // tslint:disable-next-line:no-any
  selectedTabData: any;
  roles$: Observable<Role[]>;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale , private activatedRoute: ActivatedRoute , private store: Store<fromRoot.AppState>) {
    this.roles$ = this.store.pipe(select(fromRoot.selectors.getMyRoles));
  }

  isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }
  ngOnInit(): void {}

  ngAfterContentInit(): void {
    this.setFragment(this.tabs.first);
  }

  setFragment(selectedTab: TabComponent): void {
    if (this.activatedRoute.snapshot.fragment) {
      this.tabs.toArray().forEach(tab => {
        const frag = this.activatedRoute.snapshot.fragment.replace('@', '');
        if (tab.title.toLowerCase() === frag.toLowerCase()) {
          tab.active = true;
          selectedTab = tab;
        }
      });
    }
    this.selectTab(selectedTab);
  }

  selectTab(selectedTab: TabComponent): void {
    this.selectedTabData = selectedTab;
    // deactivate all (not current) tabs
    this.tabs.toArray().forEach(tab => {
      if (selectedTab.title !== tab.title) {
        tab.active = false
      }
    });
    selectedTab.active = true;
    this.createComponent(selectedTab);
  }

  createComponent(content: TabComponent): void {
    this.tabDisplay = content;
  }

  ngOnDestroy(): void {
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
  }



}
